import {  AntibioticsTestStatus, CountRangesEnum, PassOrFail, PayablePaymentStatusEnum, PlantsEnum, QualityTypeEnum, SubPlantCodesEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { GrnItemDefects } from "./grn-item-defects.entity";
import { Grn } from "./raw-material-grn.entity";
import { CompanyTypeEnum, InvoiceStatusEnum } from "@gtpl/shared-models/masters";
@Entity('grn_items')
export class GrnItems {

    @PrimaryGeneratedColumn("increment", { name: 'grn_item_id' })
    grnItemId: number;
    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'grn_id'
    })
    grnId: number;

    // @Column({
    //     type: 'int',
    //     nullable: true,
    //     // default: 0,
    //     name: 'plant_id'
    // })
    // plantId: number;

    // @Column({
    //     type: 'int',
    //     nullable: true,
    //     // default: 0,
    //     name: 'sub_plant_id'
    // })
    // subPlantId: number;
    @Column("int", {
        nullable: false,
        name: "indent_id"
    })
    indentId: number;
    @Column("int", {
        nullable: false,
        name: "indent_item_id"
    })
    indentItemId: number;
    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "lot_number"
    })
    lotNumber: string;
    @Column("int", {
        nullable: true,
        name: "sale_order_id"
    })
    saleOrderId: number;
    @Column("int", {
        nullable: true,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;
    @Column("int", {
        nullable: true,
        name: "farmer"
    })
    farmer: number;
    @Column("int", {
        nullable: true,
        name: "farmer_code"
    })
    farmerCode: number;
    @Column("decimal", {
        nullable: true,
        name: "quantity",
        precision:10,scale:3,
        unsigned:true,
    })
    quantity: number;
    @Column("decimal", {
        nullable: true,
        name: "count",
        precision:5,scale:2,
        unsigned:true,
    })
    count: number;

    @Column("decimal", {
        nullable: true,
        name: "actual_quantity",
        precision:10,scale:3,
        unsigned:true,
    })
    actualQuantity: number;
    @Column("decimal", {
        nullable: true,
        name: "actual_count",
        precision:5,scale:2,
        unsigned:true,
    })
    actualCount: number;
    @Column("int", {
        nullable: false,
        name: "product"
    })
    product: number;
    @Column("int", {
        nullable: true,
        name: "broker",
        default: 0,
    })
    broker: number;
    @Column("decimal", {
        nullable: true,
        name: "price",
        precision:10,scale:2,
        unsigned:true,
    })
    price: number;
    @Column("int", {
        nullable: true,
        name: "received_boxes"
    })
    receivedBoxes: number;

    @Column("int", {
        nullable: true,
        name: "soft_percentage"
    })
    softPercentage: number;
    @Column("int", {
        nullable: true,
        name: "boxes"
    })
    boxes: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "vi_inspection"
    })
    isVInspectionCompleted: boolean;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "rm_inspection"
    })
    isRmInspectionCompleted: boolean;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "antibiotic_test"
    })
    isAntibioticsTestCompleted: boolean;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "assign_to_rm"
    })
    assignToRm: boolean;

    @Column("varchar", {
        nullable: true,
        name: "loose_shell"
    })
    looseShell: string;

    @Column("int", {
        nullable: true,
        name: "fungus_percentage"
    })
    fungusPercentage: number;
    
    @Column("varchar", {
        nullable: true,
        name: "remarks"
    })
    remarks: string;

    @Column("varchar", {
        nullable: true,
        name: "inv_remarks",
        length:200
    })
    invoiceRemarks: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @Column("int", {
        nullable: false,
        name: "ref_no"
    })
    monthlyRefNo: number;

    @Column('int',{
        name:'reweighment_boxes',
        nullable:true
    })
    reweighmentBoxes:number

    @Column('decimal',{
        name:'sample_quantity',
        nullable:true,
        precision:15,scale:3,
        unsigned:true,
    })
    sampleQuantity:number

    @Column('int',{
        name:'sample_pieces',
        nullable:true
    })
    samplePieces:number

    @Column('int',{
        name:'reweighment_count',
        nullable:true
    })
    reweighmentCount:number

    @Column('boolean',{
        name:'reweighment_status',
        nullable: false,
        default: false,
    })
    reweighmentStatus: boolean

    @Column('int',{
        name:'approved_price',
        nullable:true
    })
    approvedPrice:number

    @Column('decimal',{
        name:'reweighment_quantity',
        nullable:true,
        precision:15,scale:3,
        unsigned:true,
    })
    reweighmentQuantity:number

    @Column("int", {
        nullable: true,
        name: "rm_rate"
    })
    rmRate: number;

    @Column("int", {
        nullable: true,
        name: "ice_rate"
    })
    iceRate: number;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "plant_lot_number"
    })
    plantLotNumber: string;

    @Column("boolean", {
        nullable: false,
        default:false,
        name: "addon_count"
    })
    addonCount: boolean;

    @Column("enum", {
        nullable: true,
        name: "inv_status",
        enum:InvoiceStatusEnum,
        default:InvoiceStatusEnum.OPEN
    })
    invoiceStatus: InvoiceStatusEnum;

    @Column("int", {
        nullable: true,
        name: "yield_per"
    })
    yieldPer: number;

    @ManyToOne(type => Grn, grn => grn.grnItemsInfo, { nullable: false, })
    @JoinColumn({ name: "grn_id" })
    grnInfo: Grn;

    @OneToMany(type => GrnItemDefects, grnItemDefects => grnItemDefects.grnItemsInfo, { cascade: true })
    grnItemDefects: GrnItemDefects[];

    @Column("enum", {
        nullable: true,
        name: "slot",
        enum:CountRangesEnum,
    })
    slot: CountRangesEnum;

    @Column('boolean',{
        name:'reweigh_mis_flag',
        default:0
    })
    reweighMisFlag : boolean

    @Column('boolean',{
        name:'procure_mis_flag',
        default:0
    })
    procureMisFlag : boolean

    @Column('varchar',{
        name:'main_batch_num',
        length:30
    })
    mainBatchNumber : string

    @Column('int',{
        name:'year'
    })
    year:number

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "test_result"
    })
    testResult: PassOrFail;

    @Column('datetime',{
        nullable: true,
        name: "reweighment_date",
    })
    reweighmentDate: Date;
    @Column('varchar',{
        nullable: true,
        length: 50,
        name: "budget_range",
    })
    budgetRange: string;
    @Column({
        type:'enum',
        enum: AntibioticsTestStatus, 
        name: 'antibiotics_test_status',
        nullable:false,
        default:AntibioticsTestStatus.PENDING,
    })
    antibioticsTestStatus: AntibioticsTestStatus;
    
    @Column('boolean',{
        name:'tds_applicable'
    })
    tdsApplicable : boolean

    @Column('decimal',{
        name:'taxable_amount',
        precision:10,scale:2
    })
    taxableAmount : number
 @Column({
        type: 'enum',
        enum: PayablePaymentStatusEnum,
        nullable: true,
        default: PayablePaymentStatusEnum.OPEN,
        name: 'payment_status'
    })
    paymentStatus: PayablePaymentStatusEnum;

    @Column('enum',{
        nullable: true,
        name: "reweighment_bill_to",
        enum:CompanyTypeEnum
    })
    reweighmentBillTo: CompanyTypeEnum;

    @Column('decimal',{
        name:'bale_qty',
        precision:10,scale:3,
        default:0
    })
    baleQty : number

    @Column('enum',{
        name:'quality',
        enum:QualityTypeEnum,
        nullable:false
    })
    quality : QualityTypeEnum

    @Column('varchar',{
        name:'reporting_type',
        nullable:false,
        length : 10
    })
    reportingType : string
    
}
